export default __webpack_public_path__ + "static/media/chevron-down.inline.01023e41.svg";